var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldCreateWorkspace)?_c('Error',{attrs:{"error":"should-create-workspace"}}):_c('section',{attrs:{"id":"bucket"}},[_c('Bucket')],1)}
var staticRenderFns = []

export { render, staticRenderFns }